export default "__VITE_ASSET__bf8faa01__"